import React from 'react'
import {Button, Form, Input, Layout, message, Select} from "antd";
import HeaderNav from "../header/header";
const { Content } = Layout;

const { TextArea } = Input;
const { Option } = Select;

class Support extends React.Component{
    formRef = React.createRef();
    onFinish=(values)=>{
        let Lowercase = this.formRef.current.getFieldValue('Lowercase')
        if(Lowercase==='lenovo'){

        }else{
            message.warn('Please input your Type In Lowercase: LENOVO!')
        }
    }
    render() {
        return <div>
            <HeaderNav parmas={'/support'}/>
            <Layout className="site-layout-background" style={{ padding: '24px 0',width: '1000px',margin: '0 auto'  }}>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    <h1>How Can We Help You?</h1>

                    <Form
                        name="support"
                        labelCol={{ span: 6 , offset:3}}
                        wrapperCol={{ span: 7}}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        ref={this.formRef}
                    >
                        <Form.Item
                            label="Name Or Sold To"
                            name="nameOrSoldTo"
                            rules={[{ required: true, message: 'Please input your Name Or Sold To!' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Email Address"
                            name="emailAddress"
                            rules={[{ required: true, message: 'Please input your Address!' }]}
                        >
                            <Input defaultValue={'@'}/>
                        </Form.Item>

                        <Form.Item
                            label="Country"
                            name="country"
                            rules={[{ required: true,message: 'Please input your Country!' }]}
                        >
                            <Select placeholder='Please select'>
                                <Option value='AE' >Utd.Arab.Emir.(MEA)</Option>
                                <Option value='AF' >Afghanistan(MEA)</Option>
                                <Option value='AL' >Albania(SEE)</Option>
                                <Option value='AM' >Armenia(EECA)</Option>
                                <Option value='AO' >Angola(MEA)</Option>
                                <Option value='AT' >Austria(GAT)</Option>
                                <Option value='AZ' >Azerbaijan(EECA)</Option>
                                <Option value='BA' >Bosnia-Herz.(SEE)</Option>
                                <Option value='BE' >Belgium(BENELUX)</Option>
                                <Option value='BF' >Burkina-Faso(MEA)</Option>
                                <Option value='BG' >Bulgaria(SEE)</Option>
                                <Option value='BH' >Bahrain(MEA)</Option>
                                <Option value='BI' >Burundi(MEA)</Option>
                                <Option value='BJ' >Benin(MEA)</Option>
                                <Option value='BW' >Botswana(MEA)</Option>
                                <Option value='BY' >Belarus(EECA)</Option>
                                <Option value='CD' >Dem.Rep.Congo(MEA)</Option>
                                <Option value='CF' >Central Afr.Rep(MEA)</Option>
                                <Option value='CG' >Congo(MEA)</Option>
                                <Option value='CH' >Switzerland(CH)</Option>
                                <Option value='CI' >Ivory Coast(MEA)</Option>
                                <Option value='CM' >Cameroon(MEA)</Option>
                                <Option value='CV' >Cape Verde(MEA)</Option>
                                <Option value='CY' >Cyprus(SEE)</Option>
                                <Option value='CZ' >Czech Republic(CZ/SK)</Option>
                                <Option value='DE' >Germany(GAT)</Option>
                                <Option value='DJ' >Djibouti(MEA)</Option>
                                <Option value='DK' >Denmark(NORDICS)</Option>
                                <Option value='DZ' >Algeria(MEA)</Option>
                                <Option value='EE' >Estonia(NORDICS)</Option>
                                <Option value='EG' >Egypt(MEA)</Option>
                                <Option value='ER' >Eritrea(MEA)</Option>
                                <Option value='ES' >Spain(IBERIA)</Option>
                                <Option value='ET' >Ethiopia(MEA)</Option>
                                <Option value='FI' >Finland(NORDICS)</Option>
                                <Option value='FR' >France(FRANCE)</Option>
                                <Option value='GA' >Gabon(MEA)</Option>
                                <Option value='GB' >United Kingdom(UKI)</Option>
                                <Option value='GE' >Georgia(EECA)</Option>
                                <Option value='GH' >Ghana(MEA)</Option>
                                <Option value='GM' >Gambia(MEA)</Option>
                                <Option value='GN' >Guinea(MEA)</Option>
                                <Option value='GQ' >Equatorial Guin(MEA)</Option>
                                <Option value='GW' >Guinea-Bissau(MEA)</Option>
                                <Option value='HR' >Croatia(SEE)</Option>
                                <Option value='HU' >Hungary(SEE)</Option>
                                <Option value='IE' >Ireland(UKI)</Option>
                                <Option value='IL' >Israel(ISRAEL)</Option>
                                <Option value='IQ' >Iraq(MEA)</Option>
                                <Option value='IQ' >Iraq(MEA)</Option>
                                <Option value='IR' >Iran(MEA)</Option>
                                <Option value='IS' >Iceland(NORDICS)</Option>
                                <Option value='IT' >Italy(ITALY)</Option>
                                <Option value='JO' >Jordan(MEA)</Option>
                                <Option value='KE' >Kenya(MEA)</Option>
                                <Option value='KG' >Kyrgyzstan(EECA)</Option>
                                <Option value='KM' >Comoro(MEA)</Option>
                                <Option value='KW' >Kuwait(MEA)</Option>
                                <Option value='KZ' >Kazakhstan(EECA)</Option>
                                <Option value='LB' >Lebanon(MEA)</Option>
                                <Option value='LI' >Liechtenstein(CH)</Option>
                                <Option value='LR' >Liberia(MEA)</Option>
                                <Option value='LS' >Lesotho(MEA)</Option>
                                <Option value='LT' >Lithuania(NORDICS)</Option>
                                <Option value='LU' >Luxembourg(BENELUX)</Option>
                                <Option value='LV' >Latvia(NORDICS)</Option>
                                <Option value='LY' >Libya(MEA)</Option>
                                <Option value='MA' >Morocco(MEA)</Option>
                                <Option value='MD' >Moldova(EECA)</Option>
                                <Option value='ME' >Montenegro(SEE)</Option>
                                <Option value='MG' >Madagascar(MEA)</Option>
                                <Option value='MK' >Macedonia(SEE)</Option>
                                <Option value='ML' >Mali(MEA)</Option>
                                <Option value='MR' >Mauretania(MEA)</Option>
                                <Option value='MT' >Malta(MEA)</Option>
                                <Option value='MU' >Mauritius(MEA)</Option>
                                <Option value='MW' >Malawi(MEA)</Option>
                                <Option value='MZ' >Mozambique(MEA)</Option>
                                <Option value='NA' >Namibia(MEA)</Option>
                                <Option value='NE' >Niger(MEA)</Option>
                                <Option value='NG' >Nigeria(MEA)</Option>
                                <Option value='NL' >Netherlands(BENELUX)</Option>
                                <Option value='NO' >Norway(NORDICS)</Option>
                                <Option value='OM' >Oman(MEA)</Option>
                                <Option value='PK' >Pakistan(MEA)</Option>
                                <Option value='PL' >Poland(Poland)</Option>
                                <Option value='PT' >Portugal(IBERIA)</Option>
                                <Option value='QA' >Qatar(MEA)</Option>
                                <Option value='RO' >Romania(SEE)</Option>
                                <Option value='RS' >Serbia(SEE)</Option>
                                <Option value='RU' >Russian Fed.(RUSSIA)</Option>
                                <Option value='RW' >Rwanda(MEA)</Option>
                                <Option value='SA' >Saudi Arabia(MEA)</Option>
                                <Option value='SC' >Seychelles(MEA)</Option>
                                <Option value='SE' >Sweden(NORDICS)</Option>
                                <Option value='SI' >Slovenia(SEE)</Option>
                                <Option value='SK' >Slovakia(CZ/SK)</Option>
                                <Option value='SL' >Sierra Leone(MEA)</Option>
                                <Option value='SN' >Senegal(MEA)</Option>
                                <Option value='SO' >Somalia(MEA)</Option>
                                <Option value='ST' >S.Tome,Principe(MEA)</Option>
                                <Option value='SY' >Syria(MEA)</Option>
                                <Option value='SZ' >Swaziland(MEA)</Option>
                                <Option value='TD' >Chad(MEA)</Option>
                                <Option value='TG' >Togo(MEA)</Option>
                                <Option value='TJ' >Tajikistan(EECA)</Option>
                                <Option value='TM' >Turkmenistan(EECA)</Option>
                                <Option value='TN' >Tunisia(MEA)</Option>
                                <Option value='TR' >Turkey(TURKEY)</Option>
                                <Option value='TZ' >Tanzania(MEA)</Option>
                                <Option value='UA' >Ukraine(EECA)</Option>
                                <Option value='UG' >Uganda(MEA)</Option>
                                <Option value='UZ' >Uzbekistan(EECA)</Option>
                                <Option value='XK' >Kosovo(SEE)</Option>
                                <Option value='YE' >Yemen(MEA)</Option>
                                <Option value='ZA' >South Africa(MEA)</Option>
                                <Option value='ZM' >Zambia(MEA)</Option>
                                <Option value='ZW' >Zimbabwe(MEA)</Option>
                                <Option value='FO' >Faeroe(NORDICS)</Option>
                                <Option value='GL' >Greenland(NORDICS)</Option>
                                <Option value='AD' >Andorra(IBERIA)</Option>
                                <Option value='GF' >French Guinea(FRANCE)</Option>
                                <Option value='GP' >Guadeloupe(FRANCE)</Option>
                                <Option value='MC' >Monaco(FRANCE)</Option>
                                <Option value='MQ' >Martinique(FRANCE)</Option>
                                <Option value='NC' >New Caledonia(FRANCE)</Option>
                                <Option value='PF' >Frenc.Polynesia(FRANCE)</Option>
                                <Option value='PM' >St.Pier,Miquel.(FRANCE)</Option>
                                <Option value='RE' >Reunion(FRANCE)</Option>
                                <Option value='WF' >Wallis,Futuna(FRANCE)</Option>
                                <Option value='YT' >Mayotte(FRANCE)</Option>
                                <Option value='GI' >Gibraltar(UKI)</Option>
                                <Option value='JE' >Jersey(UKI)</Option>
                                <Option value='MN' >Mongolia(RUSSIA)</Option>
                                <Option value='SD' >Sudan(MEA)</Option>
                                <Option value='SM' >San Marino(ITALY)</Option>
                                <Option value='VA' >Vatican City(ITALY)</Option>
                                <Option value='SJ' >Svalbard(NORDICS)</Option>
                                <Option value='CS' >Serbia/Monteneg(SEE)</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="Reason"
                            name="reason"
                            rules={[{ required: true,message: 'Please input your Reason!' }]}
                        >
                            <Select placeholder='Please select'>
                                <Option value='1' >Invoice Related</Option>
                                <Option value='2' >BID or TPM(Promotion) Rebate Related</Option>
                                <Option value='3' >Delivery or Invoice Related</Option>
                                <Option value='4' >Marketing Claim / Special Bonus Related</Option>
                                <Option value='5' >Price Protection Related</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="Message"
                            name="message"
                            rules={[{ required: true,message: 'Please input your Message!' }]}
                        >
                            <TextArea />
                        </Form.Item>

                        <Form.Item
                            label="Type In Lowercase: LENOVO"
                            name="Lowercase"
                            rules={[{ required: true,message: 'Please input your Type In Lowercase: LENOVO!' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 9, span: 16 }}>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Content>
            </Layout>
        </div>

    }
}

export default Support;